import { OreNavBarSection } from '@edenredespana/oreneta'
import { useTranslation } from 'react-i18next'

import {
  SidebarItemModel,
  SidebarLink,
  SidebarParentLink,
  useUI,
} from '@/Shared/ui/navigation'
import { navigationTranslation } from '../navigationTranslation'
import { useWebTagPermissions } from '@/User/context'
import { WebTagPermissionEnum } from '@/Shared/domain'

interface SidebarSectionProps {
  title?: string
  hover: boolean
  items: SidebarItemModel[]
}

const SidebarSection = (props: SidebarSectionProps): JSX.Element => {
  const { hasPermission } = useWebTagPermissions()
  const { t } = useTranslation()
  const { sidebarCollapsed } = useUI()

  const visibleItems = props.items.filter((sectionItem: SidebarItemModel): boolean => {
    if (sectionItem.title === navigationTranslation.sidebar.items.invoices) {
      return hasPermission(WebTagPermissionEnum.VIEW_SHOW_INVOICES)
    }

    return true
  })

  if (visibleItems.length === 0) {
    return <></>
  }

  return (
    <OreNavBarSection
      title={t(props.title || '') || ''}
      collapse={sidebarCollapsed}
      hover={props.hover}
    >
      {visibleItems.map((sectionItem: SidebarItemModel): JSX.Element => {
        const key = sectionItem.link || sectionItem.title || `item-${JSON.stringify(sectionItem)}`
        if (sectionItem.childs) {
          return (
            <SidebarParentLink
              title={t(sectionItem.title || '')}
              icon={sectionItem.icon || <></>}
              hover={props.hover}
              childs={sectionItem.childs}
              key={key}
            />
          )
        }
        return (
          <SidebarLink
            title={t(sectionItem.title || '')}
            icon={sectionItem.icon || <></>}
            link={sectionItem.link}
            hover={props.hover}
            key={key}
          />
        )
      })}
    </OreNavBarSection>
  )
}

export { SidebarSection }
